// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import {Environment} from './environment.model';

export const environment: Environment = {
	environment: 'dev',
	production: false,
	clientID: '5cf9678b-a28f-48bb-a325-08a6ab13d54d',
	clientSecret: '4qhhw3rzjvuog0kws4kkw08okksg0gco4gc0o804g0kwg48kco',
	apiKey: '8a77b9d6-e6cc-4d71-87d8-f96c621a1245',
	UPLOAD_APIKEY: 'a6e08659-ac1e-49cf-89b2-9434f5416a02'
};
